export default __webpack_public_path__ + "static/media/user.5f8e4d1f.svg";